import {BaseMapData} from './BaseMapData'
import {StoreExpansionType, LobbyImage} from '@colonist/types'
import {MapSettingEnum, ModeSettingEnum, ScenarioSettingEnum} from '../GameEnums'
import {TranslationObject} from '@colonist/i18n'

export class MapDataSS1HeadingForNewShores56P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers56P, StoreExpansionType.CitiesAndKnightsSeafarers56P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS1HeadingForNewShores56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.headingForNewShores', options: {count: 6}}
    image = LobbyImage.MapSS1HeadingForNewShores56PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 40

    scenario = ScenarioSettingEnum.SS1HeadingForNewShores
}

export class MapDataSS2SixIslands56P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers56P, StoreExpansionType.CitiesAndKnightsSeafarers56P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS2SixIslands56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.sixIslands'}
    image = LobbyImage.MapSS2SixIslands56PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 32

    scenario = ScenarioSettingEnum.SS2TheFourIslands
}

export class MapDataSS3FogIslands56P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers56P, StoreExpansionType.CitiesAndKnightsSeafarers56P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS3FogIslands56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.fogIslands', options: {count: 6}}
    image = LobbyImage.MapSS3FogIslands56PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 39

    scenario = ScenarioSettingEnum.SS3TheFogIslands
}
export class MapDataSS4ThroughTheDesert56P extends BaseMapData {
    premiumExpansionAccess = [StoreExpansionType.Seafarers56P, StoreExpansionType.CitiesAndKnightsSeafarers56P]
    premiumMapAccess = []
    mapEnum = MapSettingEnum.SS4ThroughTheDesert56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameMaps.seafarers.throughTheDesert', options: {count: 6}}
    image = LobbyImage.MapSS4ThroughTheDesert56PPreview
    compatibleGameModes = [ModeSettingEnum.Seafarers4P, ModeSettingEnum.Seafarers56P, ModeSettingEnum.CitiesAndKnightsSeafarers4P, ModeSettingEnum.CitiesAndKnightsSeafarers56P]
    includeInFreeMapRotationIfActive = false
    isActive = true
    numberOfLandTiles = 43

    scenario = ScenarioSettingEnum.SS4ThroughTheDesert
}
